import styled from 'styled-components';
import { rem } from 'polished';
import TitleWidget from '../../core/TitleWidget';
import BoxInside from '../../core/BoxInside';

import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledBoxInside = styled(BoxInside)`
  padding-top: ${rem('30px')};
  padding-bottom: ${rem('80px')};

  .directory-wrapperBtns {
    float: right;
    padding-top: ${rem('40px')};
    padding-bottom: ${rem('18px')};
    margin-bottom: ${rem('24px')};
  }
  .directory-headerBtn {
    float: right;
    width: ${rem('215px')};
    margin-bottom: ${rem('10px')};
    margin-left: ${rem('20px')};
    ${mediaqueries.greaterThan('mobile')`
      float: none;      
      margin-bottom: 0;
      width: auto;
    `};
  }
  .Employee-wrapperTable {
    overflow-x: scroll;
  }

  ${mediaqueries.greaterThan('tabletLandscape')`
    padding-top: ${rem('55px')};
  `};
`;

const StyledTitleWidget = styled(TitleWidget)`
  fill: #fff;
  line-height: ${rem('30px')};
  margin-left: ${rem('30px')};
  padding-left: ${rem('15px')};

  & > svg {
    left: ${rem('-30px')};
  }
`;

const StyledWrapperEmployerDirectory = styled.div`
  margin-bottom: ${rem('26px')};
  clear: right;
`;

const StyledWrapperSearch = styled.div`
  text-align: right;
  clear: right;
  ${mediaqueries.greaterThan('tabletLandscape')`
    margin-bottom: ${rem('35px')};
  `};
`;

const StyledWrapperPaginator = styled.div`
  width: ${rem('50px')};
  margin: 0 auto ${rem('50px')};
`;

const StyledButtonClear = styled.button`
  color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.mediumItalic};
  font-size: ${rem('14px')};
  background: none;
  border: none;
  text-decoration: underline;
  margin-bottom: ${rem('15px')};
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: none;
  `};
`;

export {
  StyledBoxInside,
  StyledTitleWidget,
  StyledWrapperEmployerDirectory,
  StyledWrapperSearch,
  StyledWrapperPaginator,
  StyledButtonClear
};
